import { localStorageAdapter } from '@xhubio-saas/core-frontend/plugin-onboarding-yaml'

/**
 * Draft storage for the onboarding survey.
 *
 * Single, locale-stable key: the DE and EN YAMLs share one structural
 * fingerprint, so a mid-flow language switch resumes instead of restarting.
 * Lives in its own module because both the dialog (writes the draft) and the
 * completion listener (clears it on success) need it — importing it from a
 * component file would drag the whole dialog into the listener's graph.
 */
export const ONBOARDING_STORAGE = localStorageAdapter('onboarding-yaml:invoice-api-standard')
